<template>
  <div>
    <pulse-loader :loading="loading" :color="$constants.LOADING_COLOR" class="text-center"/>
    <div v-if="!loading" class="flex">
      <div class="form-group">
        <label for="">Страна поставщика</label>
        <select v-model="selectedCountry" class="form-control">
          <option v-for="country in $AllCountries" :value="country.id">{{ country.name }}</option>
        </select>
      </div>
      <div class="form-group">
        <label for="">Поставщик</label>
        <select v-model="selectedSupplier" class="form-control">
          <option v-for="supp in records[selectedCountry]" :value="supp.id">{{ supp.title }}</option>
        </select>
      </div>
      <div class="form-group flex align-items-end">
        <LoadingButton
          title="Сделать по умолчанию"
          className="btn btn-outline-success"
          :onClick="updateSupplier"
          :loading="btnLoading"
          :color="$constants.SUCCESS_COLOR"
        />
      </div>
    </div>
  </div>
</template>

<script>

import api from '@/api'
import LoadingButton from "@/components/buttons/LoadingButton";

export default {
  components: {LoadingButton},
  data() {
    return {
      loading: true,
      btnLoading: false,
      selectedCountry: null,
      selectedSupplier: null,
      records: {},
    }
  },
  computed: {
    $AllCountries() {
      return this.$store.getters['platform/countries'];
    },
  },
  created() {
    this.getSuppliers();
  },
  methods: {
    async updateSupplier() {
      this.btnLoading = true;
      const {data} = await api.post('/new/suppliers', {
        action: 'setDefault',
        supplier: {id: this.selectedSupplier}
      })
      if (data.success) {
        toastr["success"]("Сохранено");
      } else {
        toastr["warning"](data.message || "Ошибка сервера");
      }
      this.btnLoading = false;
    },
    async getSuppliers() {
      this.loading = true;
      const {data} = await api.index('/new/suppliers?noPages=true')
      this.records = data.records.reduce((acc, r) => {
        if (!acc[r.country_id]) acc[r.country_id] = [];
        acc[r.country_id].push({...r});
        return acc;
      }, {})
      this.loading = false;
    }
  }
}
</script>
